module.exports = __webpack_public_path__ + "static/img/img_cabinet.4a76d4a4.png";